import { PublicClientApplication } from "@azure/msal-browser";

import { msalConfig } from "./msalConfig";

let msalPromise = null;

export const initializeMsal = () => {
    if (!msalPromise) {
        msalPromise = (async () => {
            const instance = new PublicClientApplication(msalConfig);

            await instance.initialize();
            await instance.handleRedirectPromise();

            const accounts = instance.getAllAccounts();
            if (!instance.getActiveAccount() && accounts.length > 0) {
                instance.setActiveAccount(accounts[0]);
            }

            return instance;
        })();
    }

    return msalPromise;
};
